module.exports = __webpack_public_path__ + "img/14.ec2c5aab.jpg";